import { render } from "./RiteDetailsModal.vue?vue&type=template&id=2ef89736&scoped=true"
import script from "./RiteDetailsModal.vue?vue&type=script&lang=js"
export * from "./RiteDetailsModal.vue?vue&type=script&lang=js"

import "./RiteDetailsModal.vue?vue&type=style&index=0&id=2ef89736&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ef89736"]])

export default __exports__